"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildOrganisationBucketKey;

function buildOrganisationBucketKey(id, keySufix) {
  return "organisation/".concat(id, "/").concat(keySufix);
}